<template>
  <table class="slds-table slds-table_cell-buffer slds-table_bordered">
    <thead>
      <tr class="slds-line-height_reset">
        <th class="" scope="col">
          <div class="slds-truncate">
            &nbsp;
          </div>
        </th>
        <th class="" scope="col">
          <div class="slds-truncate">
            &nbsp;
          </div>
        </th>
        <th :aria-label="$t(`usersManagement.user.${header}`)" class="slds-is-sortable" :class="getSortClasses(header)" scope="col" v-for="header in headers" :key="header">
          <a class="slds-th__action slds-text-link_reset" role="button" tabindex="0" @click="sort(header)">
            <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
              <span class="slds-truncate" :title="$t(`usersManagement.user.${header}`)">{{ $t(`usersManagement.user.${header}`) }}</span>
              <span
                class="slds-icon_container slds-icon-utility-arrowdown">
                  <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon" aria-hidden="true">
                    <use xlink:href="../../assets/symbols.svg#arrowup"></use>
                  </svg>
              </span>
            </div>
          </a>
        </th>
      </tr>
    </thead>
    <tbody>
      <UsersTableRow
        v-for="(row, index) in rows"
        :key="row.sfmcId"
        v-model="rows[index]"
        @edit="$emit('edit', $event)"
        @deleteUser="$emit('deleteUser', $event)"
      />
    </tbody>
  </table>
</template>
<script>
import UsersTableRow from './UsersTableRow'
export default {
  components: {
    UsersTableRow
  },
  created () {
    this.rows = this.value
  },
  data () {
    return {
      headers: [
        'name',
        'email',
        'role',
        'active',
        'countries'
      ],
      rows: []
    }
  },
  methods: {
    getSortClasses (header) {
      const { field, direction } = this.sortingOptions
      return {
        'slds-is-sorted slds-is-sorted_asc': field === header && direction === 'desc',
        'slds-is-sorted slds-is-sorted_desc': field === header && direction === 'asc'
      }
    },
    isSorted (field) {
      return true
    },
    sort (header) {
      const { field, direction } = this.sortingOptions
      const sortingOptions = {}
      if (field === header) {
        sortingOptions.field = header
        if (direction === 'asc') {
          sortingOptions.direction = 'desc'
        } else {
          sortingOptions.direction = 'asc'
        }
      } else {
        sortingOptions.field = header
        sortingOptions.direction = 'asc'
      }

      this.$emit('sortChange', { sortingOptions })
    }
  },
  props: {
    sortingOptions: Object,
    value: Array
  },
  watch: {
    value (value) {
      this.rows = value
    }
  }
}
</script>
